import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Box component="footer" sx={{ py: 2.5, textAlign: 'center' }}>
      <Typography variant="body2" sx={{ fontSize: 12, color: 'text.secondary' }}>
        © {new Date().getFullYear()} ClientConnect · WhatsApp Business CRM
      </Typography>
    </Box>
  );
}
